// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NTju","newExpiryDate":"styles_newExpiryDate__38fHW","footer":"styles_footer__JsLtu"};